/* InteriorExotics motion: staggered reveal for custom sections the theme's own scroll-trigger doesn't cover. */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const targets = document.querySelectorAll(
    'main .shopify-section h2, main .ie-reveal, main .collapsible-content details'
  );
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('ie-in');
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px' }
  );
  targets.forEach((el) => {
    // skip anything already above the fold so the first paint never flashes
    if (el.closest('.scroll-trigger') || el.getBoundingClientRect().top < window.innerHeight) return;
    const siblings = el.parentElement ? [...el.parentElement.children] : [];
    el.style.setProperty('--ie-delay', `${Math.min(siblings.indexOf(el), 5) * 70}ms`);
    el.classList.add('ie-pre');
    io.observe(el);
  });
})();
